import { useTranslation } from "react-i18next";
import { motion, useAnimationControls } from "framer-motion";
import MultipleInput from "../../../../../components/input/input-register/MultipleInput";
import { EmailIcon, PlusIcon } from "../../../../../components/icons";
import { pressable } from "../../../../../components/motion";
import { isValidEmail } from "../../validation/validator";

const RECIPIENT_INPUT_ID = "emailAddress"; // rows become emailAddress0, emailAddress1, …

// A short side-to-side nudge: "fill in the current address first".
const SHAKE = { x: [0, -6, 6, -4, 4, 0], transition: { duration: 0.35 } };

const AdditionalEmail = ({
    containerClass,
    profileData,
    handleRecipientChange,
    removeRecipient,
    addRecipient,
}) => {
    const { t } = useTranslation();
    const addButtonControls = useAnimationControls();

    // A new row is only added once every existing address is valid (same rule
    // as addRecipient). Instead of silently ignoring the click, shake the
    // button and put the cursor in the row that still needs fixing.
    const handleAddClick = () => {
        const firstInvalidIndex = profileData.emailRecipients.findIndex((recipient) => !isValidEmail(recipient));
        if (firstInvalidIndex === -1) {
            addRecipient();
            return;
        }
        addButtonControls.start(SHAKE);
        document.getElementById(`${RECIPIENT_INPUT_ID}${firstInvalidIndex}`)?.focus();
    };

    return (
        <div className={containerClass}>
            <div id="EmailRecipientsSection">
                <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-0">
                    {t("businessRegister.additionalEmailRecipients.title")}
                    <span className="tw:!text-[#A7A7A7] tw:!font-[600] tw:!text-[18px] tw:!ml-2">
                        {t("businessRegister.additionalEmailRecipients.optionalText")}
                    </span>
                </p>

                <p className="tw:!text-[12px] tw:!font-[400] tw:!text-[#212529] tw:!mb-2">
                    {t("businessRegister.additionalEmailRecipients.desc")}
                </p>

                <MultipleInput
                    type="email"
                    id={RECIPIENT_INPUT_ID}
                    suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                    prefixIcon={<EmailIcon />}
                    label={t("businessRegister.additionalEmailRecipients.form.email")}
                    placeholder={t("businessRegister.additionalEmailRecipients.form.email")}
                    valueArray={profileData.emailRecipients}
                    onChange={(index, event) => handleRecipientChange(index, event.target.value)}
                    suffixClassLabel={"tw:!text-[14px] tw:!font-[400] tw:!text-[#282828]"}
                    removeIndex={(index) => removeRecipient(index)}
                />

                <motion.button
                    type="button"
                    animate={addButtonControls}
                    whileHover={pressable.hover}
                    whileTap={pressable.tap}
                    onClick={handleAddClick}
                    className="tw:flex tw:w-full tw:items-center tw:justify-center tw:gap-1.5 tw:rounded tw:border tw:border-[#EFE3C4] tw:bg-[#F9EDD3] tw:py-3 tw:text-[14px] tw:text-[#4E4E4E] tw:transition-colors tw:hover:bg-[#F5E6C4] tw:md:w-1/4"
                >
                    <PlusIcon size={16} color="#4E4E4E" />
                    {t("businessRegister.additionalEmailRecipients.form.button")}
                </motion.button>
            </div>
        </div>
    );
};

export default AdditionalEmail;
